import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Domain from "@material-ui/icons/Domain";

import {
  COMPANY_FORM,
  EDIT_COMPANY_MODAL_ID,
} from "features/planner/planner.constants";

import SimpleFormModal from "app/components/SimpleFormModal";
import { editCompanyOnSubmit } from "features/planner/planner.actions";
import CompanyForm from "features/planner/settings/company/components/CompanyForm";

class EditCompanyModal extends PureComponent {
  render() {
    const { dispatchEditCompanyOnSubmit } = this.props;

    return (
      <SimpleFormModal
        submitText="Save"
        Icon={Domain}
        title="Edit Company"
        component={CompanyForm}
        formTitleField={COMPANY_FORM.NAME}
        modalId={EDIT_COMPANY_MODAL_ID}
        onSubmit={dispatchEditCompanyOnSubmit}
        DialogProps={{
          maxWidth: "md",
        }}
        form={{
          form: COMPANY_FORM.ID,
        }}
      />
    );
  }
}

export default compose(
  connect(null, {
    dispatchEditCompanyOnSubmit: editCompanyOnSubmit,
  }),
)(EditCompanyModal);
